import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Strip out derived symbol order information
// We treat the persisted order of remote nodes as authoritative instead of relying on this value
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const isSymbolRoot = DomTypeUtils.isSymbolRoot(data);
  const hasSymOrder = data && data.sym && data.sym.order !== undefined;

  return {
    needed: isSymbolRoot && hasSymOrder,
    logData: {
      msg: 'Symbol root with data.sym.order',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.sym.order;
    },
  };
};
